'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('base/productDetail'));
    processInclude(require('./product/wishlistHeart'));
});
